import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchFront } from 'app/actions/FrontActions';
import { getFront } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function FrontContainer(props) {
    let dispatch = useDispatch();
    let front = useSelector(getFront);

    useEffect(() => {
        if (isEmpty(front)) fetchFrontAction();
    }, []);
    const fetchFrontAction = () => dispatch(fetchFront());
    return (props.children({ front }));
}